import { render, staticRenderFns } from "./CircleWithPercentages.vue?vue&type=template&id=8379fe7a&scoped=true&"
import script from "./CircleWithPercentages.vue?vue&type=script&lang=js&"
export * from "./CircleWithPercentages.vue?vue&type=script&lang=js&"
import style0 from "./CircleWithPercentages.vue?vue&type=style&index=0&id=8379fe7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8379fe7a",
  null
  
)

export default component.exports